import { PropertySavedStatechartStoreEvent } from 'common/module/property/saved/statechart/store.event';
import { PropertySavedStatechartStoreActionEnum } from 'common/module/property/saved/statechart/store-action.enum';
import { PropertySavedStatechartStoreStateEnum } from 'common/module/property/saved/statechart/store-state.enum';

export const PropertySavedStatechart = {
  initial: PropertySavedStatechartStoreStateEnum.iddle,
  on: {
    [PropertySavedStatechartStoreEvent.reset]: PropertySavedStatechartStoreStateEnum.iddle,
  },
  states: {
    [PropertySavedStatechartStoreStateEnum.iddle]: {
      on: {
        [PropertySavedStatechartStoreEvent.save]: {
          // go into loading state
          target: PropertySavedStatechartStoreStateEnum.loading,
          // add items to localstorage and send save request (if logged in)
          actions: [
            PropertySavedStatechartStoreActionEnum.addToLocalStorage,
            PropertySavedStatechartStoreActionEnum.sendSaveRequest,
          ],
        },
        [PropertySavedStatechartStoreEvent.unsave]: {
          // Go into loading state
          target: PropertySavedStatechartStoreStateEnum.loading,
          // Remove property from localstorage and send unsave request (if logged in)
          actions: [
            PropertySavedStatechartStoreActionEnum.sendUnsaveRequest,
            PropertySavedStatechartStoreActionEnum.removeFromLocalStorage,
          ],
        },
      },
    },
    // Property is unsaved
    [PropertySavedStatechartStoreStateEnum.unsaved]: {
      on: {
        // When save started
        [PropertySavedStatechartStoreEvent.save]: {
          // go into loading state
          target: PropertySavedStatechartStoreStateEnum.loading,
          // add items to localstorage and send save request (if logged in)
          actions: [
            PropertySavedStatechartStoreActionEnum.addToLocalStorage,
            PropertySavedStatechartStoreActionEnum.sendSaveRequest,
          ],
        },
      },
    },
    // Property is saved:
    [PropertySavedStatechartStoreStateEnum.saved]: {
      on: {
        // When unsave started
        [PropertySavedStatechartStoreEvent.unsave]: {
          // Go into loading state
          target: PropertySavedStatechartStoreStateEnum.loading,
          // Remove property from localstorage and send unsave request (if logged in)
          actions: [
            PropertySavedStatechartStoreActionEnum.removeFromLocalStorage,
            PropertySavedStatechartStoreActionEnum.sendUnsaveRequest,
          ],
        },
        // When save failed
        [PropertySavedStatechartStoreEvent.saveFailure]: {
          // go to unsaved state
          target: PropertySavedStatechartStoreStateEnum.unsaved,
          // remove property from local storage
          actions: [PropertySavedStatechartStoreActionEnum.removeFromLocalStorage],
        },
      },
    },
    [PropertySavedStatechartStoreStateEnum.loading]: {
      on: {
        // On save success go to saved state
        [PropertySavedStatechartStoreEvent.saveSuccess]: PropertySavedStatechartStoreStateEnum.saved,
        [PropertySavedStatechartStoreEvent.saveFailure]: PropertySavedStatechartStoreStateEnum.unsaved,
        [PropertySavedStatechartStoreEvent.unsaveSuccess]: PropertySavedStatechartStoreStateEnum.unsaved,
        [PropertySavedStatechartStoreEvent.unsaveFailure]: PropertySavedStatechartStoreStateEnum.saved,
      },
    },
  },
};
